/* file description */
import { useMemo } from 'react';
import { MergeTableColumn } from '@/components/SEFieldWithModel/effects';
import { COLUMN_FROM, LCP_EFECT_KINDS } from '@/components/SEFieldWithModel/effects/consts';
import { useGetColumnByField } from '@/components/SEFieldWithModel/effects/useGetColumnByField';
import { UseXMColumnsProp } from './type';
import { getBizConfig } from '@/common/asset-apis/getAssetModuleByRequest';
import _ from 'lodash';

export const useColumnsProp: UseXMColumnsProp = ({
  columns,
  moduleInfo,
  FetchAPI,
  mode,
  queryFormRef,
  isOpenGroup,
  storeValue,
  store,
  isMobile,
}) => {
  const APi = { FetchAPI } as any;
  const getColumnByField = useGetColumnByField({ columnFrom: COLUMN_FROM.FORM, isMobile });
  // if (isOpenGroup && !queryFormRef?.current) {
  //   return { mergeColumns: [] };
  // }
  return useMemo(() => {
    let mergeColumns: MergeTableColumn[] = [];
    const { fields = [] } = moduleInfo;
    // hashTable-一遍遍历处理
    const columnsHashTable: Record<any, any> = {};
    columns?.forEach((column) => {
      columnsHashTable[`${column.dataIndex}`] = column;
    });
    const columnsFields: Array<{
      [key: string]: any;
      options?: Record<any, any> | undefined;
    }> = [];
    // 按照columns顺序排列
    Object.keys(columnsHashTable).forEach((key) => {
      fields?.forEach((field) => {
        if (key === field.name) {
          const newField = _.cloneDeep(field);
          if (columnsHashTable[key]?.customLabel) {
            newField.label = columnsHashTable[key]?.customLabel;
          }
          columnsFields.push(newField);

          // 执行规则变更业务组件元数据 规则生产的数据columnsHashTable[key].bizComponent，field模型中已经经过转化后的数据
          if (columnsHashTable[key].bizComponent) {
            const bizConfig = getBizConfig(columnsHashTable[key].bizComponent.componentsCode);
            console.log('Match to change BizConfig:', newField, columnsHashTable[key], bizConfig);
            newField.kind = bizConfig.kind;
            newField.bizConfig = Object.assign({}, bizConfig.options, columnsHashTable[key].bizComponent?.options);
            newField.extension = Object.assign({}, field.extension, {
              tooltip: columnsHashTable[key].bizComponent?.tooltip,
              isDisabled: !columnsHashTable[key].bizComponent?.isEditable,
            });
          }

          // 处理RecordSelect联动显示字段
          if (field?.kind !== 'OpenApiSelect') {
            const { showFields = [], value: linkByFieldName } = ((field.bizConfig || field.options || {}) as { showFields: []; value: string });
            showFields?.forEach((showField: { key: any; realLabel: any; showModule?: string; showModuleLabel?: string; showModuleValue?: string }) => {
              columnsFields.push({
                kind: LCP_EFECT_KINDS.LINK_SHOW_RECORD,
                name: showField?.key,
                linkBy: field.name,
                label: showField?.realLabel,
                linkByFieldName,
                linkByLabel: field.label,
                linkByField: field,
                showModule: showField?.showModule,
                showModuleLabel: showField?.showModuleLabel,
                showModuleValue: showField?.showModuleValue,
                showNamespace: showField?.showNamespace,
                isImg: showField?.isImg,
              });
            });
          }
        }
      });
    });
    mergeColumns = columnsFields
      ?.map((field) =>
        getColumnByField({
          mode,
          field,
          mergeColumn: columnsHashTable[field.name],
          moduleInfo,
          queryFormRef,
          isOpenGroup,
          storeValue,
          store,
        }));
    mergeColumns.forEach((item) => {
      item.width = item.width || '100%';
      item.proFieldProps = {
        ...(item.proFieldProps || {}),
        mode,
      };
    });

    return {
      mergeColumns: mergeColumns || [],
    };
    // }, [moduleInfo, columns, mode]);
    // 深度比对
  }, [JSON.stringify(moduleInfo), JSON.stringify(columns), mode]);
};
